import { Component, OnInit, Inject } from '@angular/core';
import { SharedService } from '../../shared/shared.service';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { LocalStorageService } from 'angular-2-local-storage';
import { AbstractControl } from '@angular/forms';
import { LoggerService } from './../../logger/logger.service';
import { AgentService } from '../agent.service';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { FormsModule, FormControl, FormBuilder, Validators, ReactiveFormsModule} from '@angular/forms';
const MOBILE_REGEX = /^((?!(0))[0-9]{1,10})$/;
declare var $: any;
@Component({
  selector: 'app-account-search',
  templateUrl: './account-search.component.html',
  styleUrls: ['./account-search.component.css']
})
export class AccountSearchComponent implements OnInit {

  search_key: any;
  is_validate: any;
  private screen: string = 'account_search';
  mobilePhoneFormControl = new FormControl('', [
    Validators.required,
  ]);

  constructor(private activatedRoute: ActivatedRoute,
              private sharedService: SharedService, private dialog: MatDialog,private logger:LoggerService, private router: Router,
              private localStorageService: LocalStorageService, private agentService: AgentService)
  {
    this.sharedService.setHeaderTitle(this.screen);
    this.sharedService.IsTheSessionValid(this.screen, true);
    this.search_key = '';
   }

  ngOnInit() {
  }

  validate(event: any) {
    if (this.search_key !== '') {
      this.is_validate = true;
      if (event.keyCode === 13) {
        document.getElementById('btn-click').click();
      }
    } else {
      this.is_validate = false;
    }
  }
  searchAccount() {

    this.sharedService.setLoader(this.screen, true);
    this.sharedService.setHeaderErrorMessage(this.screen, false, 'notification error', '');
    this.sharedService.setHeaderSuccessMessage(this.screen, false, '');
    let methodName = this.constructor.name + '.isValidMobilePhoneAndAccount';

    this.agentService.loginAs({'searchTerm' : this.search_key, 'isAgent': true,
      'token': this.localStorageService.get('agentToken')
    })
      .then(res =>
      {
        this.sharedService.setLoader(this.screen, false);
        this.localStorageService.set('token', res.token);
        this.router.navigate(['./dashboard']);
      })
      .catch((ex) => {
        this.sharedService.setLoader(this.screen, false);
        this.sharedService.setHeaderErrorMessage(this.screen, true, 'notification error', ex._body);
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/agent/account-search/account-search.component.ts